/**
 * BİR ONAY SATIRI NE DURUMDA — ve öğrenciye nasıl söyleniyor
 *
 * ================================================================
 * "VERİLMEDİ" TEK BİR ŞEY DEĞİL
 * ================================================================
 * Ölçüldü (05.09.2026, C14.32): sunucu `engelleyenEksikler` ve
 * `eksikIstegeBagli` diye **iki ayrı** liste gönderiyor. Panel ikisini
 * de okuyor ve orada şu yazılı:
 *
 *   > "`eksikIstegeBagli` sunucudan geliyordu ve HİÇBİR EKRAN
 *   >  OKUMUYORDU — bu depoda tanıdık sınıf. Alanın tek amacı zaten bu
 *   >  ayrımı yapabilmekti."
 *
 * Panel bunu görüp düzeltmiş; **öğrenci ekranı düzeltilmemişti.** Yani
 * teşhis edilmiş bir hata, teşhis edilmediği yerde duruyordu.
 *
 * Öğrencide bedeli daha ağır: iki liste ayrılmadığında her verilmemiş
 * onay aynı cümleyle ("Henüz onaylanmadı") görünüyor ve öğrenci
 * **isteğe bağlı olanı da eksik bir görev** sanıyor.
 *
 * ================================================================
 * NEDEN BU BİR KVKK MESELESİ
 * ================================================================
 * Rızanın geçerli olması için **özgür iradeyle** verilmiş olması
 * gerekiyor. Vermek zorunda olmadığı bir onayı "eksik" diye gören
 * öğrenci, onu tamamlanması gereken bir işmiş gibi verir — ve o rıza
 * artık gönüllü değildir. Ekranın sessizliği, rızanın niteliğini
 * değiştiriyor.
 *
 * Bu yüzden dil panelden KOPYALANMIYOR: panelde bu bir yönetim
 * bilgisi ("bu kişi şunu vermemiş"), öğrencide bir **seçenek**
 * ("verebilirsin, vermek zorunda değilsin").
 */

export type RizaSatirDurumu =
  "onayli" | "surum-eskimis" | "eksik-zorunlu" | "eksik-istege-bagli" | "eksik";

export interface RizaSatirGirdisi {
  /** Yürürlükteki sürüme verilmiş geçerli bir onay var mı */
  gecerli: boolean;
  /** Herhangi bir sürüme verilmiş kayıt var mı (eskimiş olabilir) */
  kayitVar: boolean;
  /** `engelleyenEksikler` içinde mi — hesabı durduruyor */
  engelliyorMu: boolean;
  /** `eksikIstegeBagli` içinde mi — vermek zorunda değil */
  istegeBagliMi: boolean;
}

export function rizaSatirDurumu(g: RizaSatirGirdisi): RizaSatirDurumu {
  if (g.gecerli) return "onayli";
  if (g.kayitVar) return "surum-eskimis";
  if (g.engelliyorMu) return "eksik-zorunlu";
  if (g.istegeBagliMi) return "eksik-istege-bagli";
  /*
    Sunucu iki listeden hiçbirinde saymadıysa ekran BİR ŞEY UYDURMUYOR.
    "İsteğe bağlı" demek, sunucunun söylemediği bir şeyi söylemek
    olurdu — ve bu ekranda o cümle bir hak beyanı.
  */
  return "eksik";
}

/** Satırın altındaki açıklama; `onayli` hâli çağıran tarafta yazılıyor. */
export function rizaSatirMetni(durum: RizaSatirDurumu): string | null {
  switch (durum) {
    case "surum-eskimis":
      return "Metin değişti, yeniden onaylaman gerekiyor";
    case "eksik-zorunlu":
      return "Bu onay gerekli — verilmeden hesabın kullanılamıyor";
    case "eksik-istege-bagli":
      /*
        "Eksik" KELIMESI YOK ve olmamalı: eksik olan bir şey
        tamamlanmayı bekler, bu ise beklemiyor. Cümle önce seçeneği,
        sonra özgürlüğü söylüyor.
      */
      return "İsteğe bağlı — vermek zorunda değilsin";
    case "eksik":
      return "Henüz onaylanmadı";
    case "onayli":
      return null;
  }
}
